import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import OurModel from "@/pages/OurModel";
import Team from "@/pages/Team";
import UMCC from "@/pages/UMCC";
import Investors from "@/pages/Investors";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-bone text-ink antialiased">
      <BrowserRouter>
        <Header />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-model" element={<OurModel />} />
            <Route path="/team" element={<Team />} />
            <Route path="/umcc" element={<UMCC />} />
            <Route path="/policy-leadership" element={<UMCC />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
